/* The "01 / PHILOSOPHY" eyebrow above each section. Number + label are
   resolved from the editable section registry (useSections) by key, so
   renaming or reordering in /admin reflects in the section bodies too.
   Falls back gracefully if the key isn't found. */
import { useSections } from '../content/ContentContext.jsx'

export function SectionNum({ sectionKey }) {
  const sections = useSections()
  const s = sections.find((x) => x.key === sectionKey)
  const num = s?.num ?? ''
  const label = (s?.label ?? sectionKey).toUpperCase()
  return (
    <div className="sec-num">
      {num} <span>/ {label}</span>
    </div>
  )
}
